import React, { useEffect, useRef, useState } from 'react';
import styles from './RecordingActions.module.scss';
import { useTranslation } from 'react-i18next';
import InstallExtensionModal from '../../../../components/InstallExtensionModal/InstallExtensionModal';
import cx from 'classnames';
import useOutsideClick from '../../../../hooks/useOutsideClick';

const RecordingActions = props => {
  const { disableShowRecordingActions = () => {}, onRedirect, folderId = null, handleShowUploadVideoModal } = props;
  const { t } = useTranslation();

  const [isShowModal, setIsShowModal] = useState(false);

  const ref = useRef(null);

  useOutsideClick(ref, () => disableShowRecordingActions());

  const extensionId = process.env.EXT_ID;
  const handleRecord = async () => {
    const extensionExists = document.getElementById(extensionId);

    if (extensionExists) {
      window.postMessage({ type: extensionId, message: 'OPEN_POPUP_IN_IFRAME', folderId: folderId }, '*');
      disableShowRecordingActions();
    } else {
      window.location = `vormats-video-storyteller://`;
      setTimeout(() => {
        if (localStorage.getItem('recorderInstalled') !== 'true') {
          setIsShowModal(true);
        }
      }, 1000);
    }
  };

  const handleUpload = async () => {
    handleShowUploadVideoModal();
    disableShowRecordingActions();
  };

  useEffect(() => {
    return () => disableShowRecordingActions();
  }, []);

  return (
    <>
      <InstallExtensionModal open={isShowModal} onClose={disableShowRecordingActions} />
      {!isShowModal && (
        <div ref={ref} className={cx(styles.modal)}>
          <button className={styles.btn} onClick={onRedirect}>
            <span>{t('dashboard.new_video.project.button')}</span>
          </button>
          <button className={styles.btn} onClick={handleRecord}>
            <span>{t('dashboard.new_video.record_video.button')}</span>
          </button>
          <button className={styles.btn} onClick={handleUpload}>
            <span>{t('dashboard.new_video.upload_video.button')}</span>
          </button>
        </div>
      )}
    </>
  );
};

export default RecordingActions;
